export class AddOrUpdateDocComment {
    public commentId : string | undefined;

    public lineItemId : string | undefined;
    public value : string;
}